import { combineReducers } from 'redux';
import authorizationReducer from './authorization/reducer';
import alertsForm from './alertsForm/reducer';
import alertsData from './alertsData/reducer';
import appConfig from './appConfig/reducer';
import profileData from './profileData/reducer';
export default combineReducers({
    authorizationReducer: authorizationReducer,
    alertsForm: alertsForm,
    alertsData: alertsData,
    appConfig: appConfig,
    profileData: profileData
});
